import * as React from 'react';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import {
  trackAddToCard,
  trackAddToWishList,
  trackRemoveFromWishList,
  trackViewItem,
  trackViewItemList,
} from '../../tracking';

import { SkaEventName, SkaTrackingEvent } from './model';

export const useTracking = () => {
  const { getTimeFromInit } = useTrackingContext();

  const dispatchTrackingEvent = React.useCallback(
    (event: SkaTrackingEvent) => {
      const eventPayloadParams = event.payload.payload;

      switch (event.payload.name) {
        case SkaEventName.OpenProductDetails:
          trackViewItem(eventPayloadParams);
          return;
        case SkaEventName.ViewItemList:
          trackViewItemList(eventPayloadParams.items);
          return;
        case SkaEventName.AddToWishList:
          trackAddToWishList(eventPayloadParams, getTimeFromInit());
          return;
        case SkaEventName.RemoveFromWishList:
          trackRemoveFromWishList(eventPayloadParams, getTimeFromInit());
          return;
        case SkaEventName.AddToCart:
          trackAddToCard(eventPayloadParams);
          return;
        default:
          break;
      }
    },
    [getTimeFromInit]
  );

  return { dispatchTrackingEvent };
};
